import { CommonModule } from '@angular/common';
import { Component, OnInit, Input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-printer-footer',
  templateUrl: './printer-footer.component.html',
  styleUrls: ['./printer-footer.component.css'],
  imports: [
    CommonModule,
    TranslateModule
  ],
  standalone: true
})

// This class is responsible for Display page number and address details in footer
export class PrinterFooterComponent implements OnInit {

  @Input() pageNumber: string;
  constructor() { }

  ngOnInit(): void {
  }

}
